import { get } from 'lodash';
import React, { FC } from 'react';
import { FormattedNumber } from 'react-intl';

import {
  MessageType,
  ReverseMoneyNumberAmount,
} from '@savgroup-front-common/types';

import {
  safeFormattedIntlString,
  SafeFormattedMessageWithoutSpread,
} from '../../../../formatters';
import { StringHelper } from '../../../../helpers/stringHelpers';
import { $HighlightedMatch } from '../Autocomplete.styles';

import { $Container, $Price } from './OptionValueWithPriceFormatter.styles';

interface OptionValueWithPriceFormatterProps {
  priceField?: string;
  data?: any;
  label: string | MessageType;
  search?: string;
}

export const OptionValueWithPriceFormatter: FC<
  OptionValueWithPriceFormatterProps
> = ({ label, data, priceField = 'price', search }) => {
  const price = get(data, [priceField]) as ReverseMoneyNumberAmount;

  if (!search) {
    return (
      <$Container>
        {label && <SafeFormattedMessageWithoutSpread message={label} />}
        {price ? (
          <$Price>
            <FormattedNumber value={price?.amount} format={price?.currency} />
          </$Price>
        ) : undefined}
      </$Container>
    );
  }

  const labelString = safeFormattedIntlString(label);
  const segments = StringHelper.highlightSearchMatches({
    target: labelString,
    searchString: search,
  });

  return (
    <$Container>
      {label &&
        segments.map((segment, index) => {
          if (segment.isMatch) {
            return (
              <$HighlightedMatch key={index}>{segment.text}</$HighlightedMatch>
            );
          }

          return <React.Fragment key={index}>{segment.text}</React.Fragment>;
        })}
      {price ? (
        <$Price>
          <FormattedNumber value={price?.amount} format={price?.currency} />
        </$Price>
      ) : undefined}
    </$Container>
  );
};
